import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
const IconUserAccount = props => {
  const $ = _c(6);
  const color = props.color || "#585858";
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M1 17a9 9 0 0118 0M14 4.5a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0z" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== color) {
    t1 = <g stroke={color} strokeWidth={1.667} fill="none" fillRule="evenodd">{t0}</g>;
    $[1] = color;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props || $[4] !== t1) {
    t2 = <svg width={20} height={17} viewBox="0 0 20 17" {...props}>{t1}</svg>;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
IconUserAccount.propTypes = {
  color: PropTypes.string
};
export default IconUserAccount;